export const msToDays = 1000 * 3600 * 24;
